import { useContext } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetEventDocuments } from "../api/user";
import DocumentsTable from "../components/UserDocuments/DocumentsTable";
import { AuthContext } from "../services/context";
import { usePageTitle } from "../services/HeaderTitleContext";
import { getCurrentWorkspace } from "../services/userConfig";

export default function DocumentsByFileName() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace?.eventId;
  const { distributionId } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const limit = parseInt(searchParams.get("limit") || "10", 10);

  const { data: documents, isPending: isDocumentsPending } =
    useGetEventDocuments({
      eventId,
      page,
      limit,
      distributionId: Number(distributionId),
    });

  usePageTitle(documents?.distributionFileName ?? null);

  return (
    <DocumentsTable
      data={documents}
      isPending={isDocumentsPending}
      page={page}
      limit={limit}
      onPageChange={(newPage) => setSearchParams({ page: newPage, limit })}
    />
  );
}
